export default {
  install (Vue, options) {
    Vue.mixin({
      data () {
        return {
          loading_screen: null,
          loading_screen_to: null
        }
      },
      methods: {
        showLoadingScreen () {
          if(this.loading_screen) return
          this.loading_screen = this.$loading.show()
        },
        hideLoadingScreen () {
          if (this.loading_screen && this.loading_screen.hide) {
            this.loading_screen.hide()
            this.loading_screen = null
          }
        },
        setLoadingScreenTimeout () {
          this.loading_screen_to = setTimeout(() => {
            this.hideLoadingScreen()
          }, 5000);
        },
        resetLoadingScreenTimeout() {
          clearTimeout(this.loading_screen_to)
          this.setLoadingScreenTimeout()
        },
      },
      watch: {
        loading_screen (value) {
          if (value != undefined) {
            this.resetLoadingScreenTimeout()
          }
        }
      }
    })
  }
}
